import * as React from 'react';
import Strings from "../../assets/strings";

import {alpha, Box, ButtonGroup, Grid, Paper, Theme, Typography} from '@mui/material';
import Notifications from "react-notification-system-redux";
import {useAppSelector} from "../../redux/hooks";
import makeStyles from "@mui/styles/makeStyles";
import bgLoginPersonas from '../../assets/img/bg-login.jpg';
import Button from "@mui/material/Button";


const useStyles = makeStyles((theme:Theme) => ({
    root:{
        background: `#fafafa url(https://html.vristo.sbthemes.com/assets/images/map.svg) no-repeat center`,
        backgroundSize:"cover",
//    background: `linear-gradient(bottom,${theme.palette.secondary.main},${theme.palette.primary.main})`,https://html.vristo.sbthemes.com/assets/images/map.svg https://preview.keenthemes.com/metronic8/demo1/assets/media/auth/bg6.jpg   https://img.freepik.com/free-vector/minimal-desktop-background-white-abstract-design-vector_53876-135921.jpg?w=1380&t=st=1683761223~exp=1683761823~hmac=e7bba377d0f1493f09c1e7cf7bbce9a464284ab5042e7501b18c26c4bf72f842
        display:"flex",
        flexDirection:"column",
        justifyContent:"center",
        alignItems:"center",
        height: "100%",
        position: "relative",
        zIndex: 1,
        padding: 10,
        boxSizing:"border-box",

        //background:theme.palette.grey[100],
        [theme.breakpoints.down('sm')]: {
            boxSizing: "border-box",
            background:"none"
        },

    },
    linksTerm:{
        fontSize: 13,
        marginTop: 12,
        marginBottom: 10,
        "& a":{
            color: "#6b6b6b",
        }
    },
    content:{
        width:800,
        height:516,
        boxShadow: "0px 0px 9px",
        borderRadius: "5px",
       // paddingRight:theme.spacing(3),
        //paddingLeft:theme.spacing(3),
        [theme.breakpoints.down('md')]: {
            width:"100%",
            height: "auto",
            boxShadow: "none"
        },
        // backgroundColor: "rgba(0, 0, 0, 0.4)",
        // color: "rgba(255,255, 255, 0.8)",
        // boxShadow: "0px 2px 1px -1px rgb(255, 255, 255, 0.2), 0px 1px 1px 0px rgb(255, 255, 255, 0.14), 0px 1px 3px 0px rgb(255, 255, 255, 0.12)",
    },
    logo:{
        fontSize: 32,
        fontWeight: 500,
       // marginBottom: theme.spacing(2)
    },
    sideInfo:{
        background: `#1c63c6 url(${bgLoginPersonas}) no-repeat center`,
        backgroundSize: "cover",
        backgroundPosition: "-62px 0px",
        borderRadius: "5px 0px 0px 5px",
    },
    sideInfoCont:{
        // fontFamily: '"Arial Narrow", Arial, sans-serif',
        borderRadius: "4px 0px 0px 4px",
        fontSize: '18px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexDirection: 'column',
        background: alpha(theme.palette.primary.main,0.9),
        textAlign:"center",
        height: "100%",
        padding: "0 28px",
        color: "#ffffff",
        [theme.breakpoints.only('xs')]: {
            display:"none"
        },
    },
    moreInfo:{
        position: "absolute",
        width: "100%",
        left: 0,
        bottom: 0,
        [theme.breakpoints.up('sm')]: {
            width: 400,
            left: "50%",
            marginLeft:-200,
            borderRadius:2,
            bottom: 10,
        },
    },
    lang:{
        marginTop: 10,
        marginBottom: 13,
        "& label":{
            display:"block",
            fontSize: ".8em",
        },
        "& select":{
            padding: "2px 7px",
            fontSize: "1em",
        }
    },
}));
const style = {
    NotificationItem: { // Override the notification item
        DefaultStyle: { // Applied to every notification, regardless of the notification level
            margin: '10px 5px 2px 1px',
            borderRadius: '0px',
            boxShadow:"none",
        },
    },
    Dismiss: {
        DefaultStyle: {
            backgroundColor: "none",
            color: '#bbbbbb',
        },
    }
};
export default function LayOutLogin({children}:{children:any}) {
    const notifications = useAppSelector(state=> state.notifications);
    const classes = useStyles();

    return (
        <>
           <div className={classes.root}>
               <Paper className={classes.content}>
                   <Grid container component="main" sx={{ height: '100%' }}>
                       <Grid item xs={12} sm={6} className={classes.sideInfo}>
                           <div className={classes.sideInfoCont}>
                               <h3 style={{ fontSize: '36px', fontWeight:"normal",margin: 0}}>Bienvenido</h3>
                               <span>a la plataforma PrestamitApp</span>
                               <p style={{marginTop: "28%"}}>El Sistema de administración de préstamos diseñado para financieras y prestamistas que deseen automatizar su negocio.</p>
                           </div>
                       </Grid>
                       <Grid item xs={12} sm={6} sx={{
                           position: "relative",
                           display: "inline-grid",
                           alignItems: "center"
                       }}>
                           <Box
                               sx={(theme)=>({
                                   my: 4,
                                   mx: 2,
                                   display: 'flex',
                                   flexDirection: 'column',
                                   alignItems: 'center',
                                   [theme.breakpoints.down('sm')]: {
                                       margin: "28px",
                                   },
                               })}
                           >
                               <Typography className={classes.logo} color={"primary"} variant={"h2"}>PretamistAPP 3.0</Typography>
                               <Typography sx={{fontSize: 14, color: "#7b7b7b"}}>{Strings.slogan}</Typography>
                               {/*<br/>*/}
                               {/*<br/>*/}
                                   {/*<img src={logo} alt="Prestamitapp" className={classes.logo}/>*/}

                               {children}

                           </Box>
                       </Grid>

                   </Grid>
               </Paper>
               <Notifications notifications={notifications} style={style} />
               <div className={classes.linksTerm}>
                   <a target={"_blank"} rel="noreferrer" href="https://prestamistapp.com/PoliticaDePrivacidad" style={{marginRight:"10px"}}>Política de Privacidad</a>

                   <a target={"_blank"} rel="noreferrer" href="https://prestamistapp.com/TerminosYcondiciones">Términos y Condiciones</a>
               </div>


               <ButtonGroup variant="text" className={classes.moreInfo}>
                   <Button
                       component={"a"}
                       fullWidth
                       href={"https://www.instagram.com/dsegura_srl"}
                       target={"_blank"}>
                       Instagram
                   </Button>
                   <Button
                       component={"a"}
                       fullWidth
                       href={"http://prestamistapp.com/?p=true"}
                       target={"_blank"}>
                       Más info...
                   </Button>
               </ButtonGroup>
               {/*<Copyright sx={{*/}
               {/*    position: "absolute",*/}
               {/*    right: 15,*/}
               {/*    bottom: 6,*/}
               {/*}}/>*/}

           </div>

        </>
    );
}
